import LaddaButton from 'App/components/LaddaButton';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Modal } from 'react-bootstrap';

const propTypes = {
    onHide: PropTypes.func.isRequired,
    onSuccess: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
};

const defaultProps = {
    isLoading: false,
};

const WarningModal = ({ onHide, onSuccess, isLoading }) => {
    return (
        <Modal show backdrop="static" className="patient-view-profile-notes">
            <Modal.Header>
                <Modal.Title role="heading">Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Amount funded entered is higher than normal, please confirm before continuing. For recommended
                    calculations:{' '}
                    <a
                        href="https://tkn-cdn.therigy.com/walkme/resources/TherigySTM_Resource_Amount_Funded_Guide.pdf"
                        target="blank"
                    >
                        Calculating Amount funded
                    </a>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <FormButtonGroup>
                    <Button
                        variant="outline-secondary"
                        id="view-notes-close-modal-button"
                        type="button"
                        onClick={onHide}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <LaddaButton
                        isLoading={isLoading}
                        variant="primary"
                        id="add-notes-button"
                        type="button"
                        onClick={onSuccess}
                    >
                        Save Activity
                    </LaddaButton>
                </FormButtonGroup>
            </Modal.Footer>
        </Modal>
    );
};

WarningModal.propTypes = propTypes;
WarningModal.defaultProps = defaultProps;
export default WarningModal;
